module.exports = "/images/project-on-hold-icon.svg?9912c08d11daed5fa8ccfa91dab0f7f6";